import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const DeathTimeBars = () => {
    const { chartData } = useResultsChartsDataContext();


    return (
        <SimpleBars
            title={'Hora do óbito'}
            horizontal={false}
            subtitles={chartData?.deathTime?.map((item) => item.description)}
            values={chartData?.deathTime?.map((item) => item.total  ||  0)}
        />
    );
};
